export const MORTGAGE_LOAN_RATES_HEADER = 'Mortgage Loan Rates';
export const MORTGAGE_LOAN_DETAILS_HEADER = 'Mortgage Loan Details';
export const HAS_TRADE_IN = 'Has Trade In?';

export const TEN = 10;
export const FIFTEEN = 15;
export const TWENTY = 20;
export const TWENTY_FIVE = 25;
export const THIRTY = 30;

export const TEN_YRS = '10 yrs';
export const FIFTEEN_YRS = '15 yrs';
export const TWENTY_YRS = '20 yrs';
export const TWENTY_FIVE_YRS = '25 yrs';
export const THIRTY_YRS = '30 yrs';

export const MORTGAGES_SELECT_OPTIONS = [
  { text: TEN_YRS, value: 10 },
  { text: FIFTEEN_YRS, value: 15 },
  { text: TWENTY_YRS, value: 20 },
  // { text: TWENTY_FIVE_YRS, value: 25 },
  { text: THIRTY_YRS, value: 30 },
];

export const MORTGAGE_LOAN_TERMS = {
  [TEN]: {
    text: TEN_YRS,
  },
  [FIFTEEN]: {
    text: FIFTEEN_YRS,
  },
  [TWENTY]: {
    text: TWENTY_YRS,
  },
  // [TWENTY_FIVE]: {
  //   text: TWENTY_FIVE_YRS,
  // },
  [THIRTY]: {
    text: THIRTY_YRS,
  },
};

export const DEFAULT_MORTGAGE = [30];

export const DEFAULT_SELECTED_MORTGAGE_TERMS = { [THIRTY]: 360 };
